import { AppRoutes } from '../../app.app-manager-routes';
import { EntityManagerInfo } from '../../models/entity-config';

// Censimento delle voci del modulo diplomi: solo dati, nessuna EMC (spec 2026-10-19 §5).
// Generato da tools/split-app-manager-routes.mjs; le EMC stanno nel data delle rotte e nelle EMC che aprono le modali.
export class DiplomiRoutes {
  static readonly SearchCaniDiplomi: EntityManagerInfo = {
    id: 'SearchCaniDiplomi',
    name: 'searchcanidiplomi',
    translateSuffixs: ['generic.', 'searchcanidiplomi.'],
    url: 'searchcanidiplomi',
    parent: AppRoutes.Diplomi
  };

  // StampaInviti
  static readonly StampaInviti: EntityManagerInfo = {
    id: 'StampaInviti',
    name: 'stampainviti',
    translateSuffixs: ['generic.', 'stampainviti.', 'eecatalogo.', 'searchcanidiplomi.'],
    url: 'stampa-inviti',
    parent: AppRoutes.Diplomi
  };
}
